import React from 'react';
import { HashRouter } from 'react-router-dom';
import Header from 'src/layout/Header/Header';
import Routing from 'src/layout/Routing/Routing';
import { Box, Container, useTheme } from '@mui/material';
import Footer from '../Footer/Footer';

const Layout: React.FC = () => {
  const theme = useTheme()
  console.log(theme)
  return (
    <HashRouter>
      <Header />
      <Box sx={{ minHeight: '75vh'}}>
        <Routing />
      </Box>
      <Footer />
    </HashRouter>
  );
};

export default Layout;
